import type { ResourceType } from '@/features/download-portal/download-portal.types';

function url<P extends string>(path: P): P {
  return <P>`/dashboard${path}`;
}

const API = {
  get login() {
    return url('/v1/authenticate/login');
  },
  get logout() {
    return url('/v1/authenticate/logout');
  },
  get profile() {
    return url('/v1/profile');
  },
  get roleAccess() {
    return url('/v1/role/access');
  },
  // Account Settings
  get bankList() {
    return url('/v1/bank');
  },
  get businessProfile() {
    return url('/v1/business/detail');
  },
  get businessUser() {
    return url('/v1/business/users');
  },
  get businessUserPending() {
    return url('/v1/business/users/pending');
  },
  get businessUserInvitation() {
    return url('/v1/business/invite/user');
  },
  get checkoutSettings() {
    return url('/v1/business/setting');
  },
  // Main Dashboard
  get latestTransactions() {
    return url('/v1/latest-transaction');
  },
  get balance() {
    return url('/v1/balance');
  },
  // Deposit VA
  get depositPaymentMethod() {
    return url('/v1/deposit/payment-method');
  },
  get depositVA() {
    return url('/v1/deposit/va');
  },
  // Transaction
  get transactions() {
    return url('/v1/transaction');
  },
  get transactionCsvUrl() {
    return url('/v1/transaction/download/csv');
  },
  get transactionReport() {
    return url('/v1/transaction-report');
  },
  // Invoices
  get deposit() {
    return url('/v1/deposit');
  },
  get depositVAList() {
    return url('/v1/deposit/va');
  },
  // Merchant
  get merchantUrl() {
    return url('/v1/merchants');
  },
  getPaymentMethodByMerchantIdUrl(id: number | string) {
    return url(`/v1/payment-methods/${id}`);
  },
  // profile
  get enable2FA() {
    return url('/v1/enable-login-otp');
  },
  get changePassword() {
    return url('/v1/change-password');
  },
  get virtualAccounts() {
    return url('/v1/payment/va');
  },
  get qrisReport() {
    return url('/v1/payment/qris');
  },
  get webhoookMutation() {
    return url('/v1/callback/retry');
  },
  get webhookHistory() {
    return url('/v1/callback/webhook-history');
  },
  get disbursementReport() {
    return url('/v1/disbursement');
  },
  get balanceDeposit() {
    return url('/v1/balance/deposit');
  },
  get notificationPreference() {
    return url('/v1/notification-preference');
  },
  get notificationConfig() {
    return url('/v1/notification-configurations');
  },

  get settlementReport() {
    return url('/v1/settlement-doc');
  },
  get settlementSummary() {
    return url('/v1/settlement');
  },

  get directDebitReport() {
    return url('/v1/payment/directdebit');
  },

  get webhook() {
    return url('/v1/callback');
  },
  // Batch Disbursement
  get batchDisbursementUpload() {
    return url('/v1/batch-disbursement/upload');
  },
  get ApproveOrRejectDisbursementUpload() {
    return url('/v1/batch-disbursement/approve');
  },
  get batchDisbursement() {
    return url('/v1/batch-disbursement');
  },

  getBatchDisbursementByID(id: string) {
    return url(`/v1/batch-disbursement/${id}`);
  },

  get pocket() {
    return url('/v1/balance/pocket');
  },

  get cashFlow() {
    return url('/v1/balance/ledger');
  },

  get accountGroup() {
    return url('/v1/business-group');
  },

  get secretKey() {
    return url('/v1/secret-api-key');
  },

  get webhookCallback() {
    return url('/v1/business/callback-url');
  },

  get registerMember() {
    return url('/v1/authenticate/register/member');
  },

  get accountGroupCommission() {
    return url('/v1/group-commission');
  },

  get downloadPortalReport() {
    return url('/v1/reports');
  },

  get downloadPortalRequestReport() {
    return url('/v1/reports/export');
  },

  getDownloadPortalReportStatus(id: string) {
    return url(`/v1/reports/${id}/status`);
  },

  getDownloadReportFileUrl(type: ResourceType, id: string) {
    return url(`/v1/reports/download/${type}/${id}`);
  },

  get creditCard(): string {
    return url('/v1/payment/creditcard');
  },
  // Analytic Dashboard
  get aggregate() {
    return url('/v1/aggregate-dashboard');
  },
  get todayStat() {
    return url('/v1/transaction/today-stat');
  },
  getVolumeAggregate(groupName: string) {
    return url(`/v1/aggregate-dashboard/volume?group_by=${groupName}`);
  },
  getTrendAggregate(range: string) {
    return url(`/v1/aggregate-dashboard/trend?range=${range}`);
  },
  get bannerAnnouncement() {
    return url('/v1/announcement/live');
  },
  get otp2FASetup() {
    return url('/v1/2fa/setup');
  },
  get otp2FAConfirm() {
    return url('/v1/2fa/confirm');
  },
  otp2FAConfirmStep(step: 1 | 2) {
    return url(`/v1/2fa/confirm/step${step}`);
  },
  get authVerifyLogin() {
    return url('/v1/authenticate/verify-otp');
  },
  V2: {},
};

export default API;
